module.exports = new __parcel__URL__("start-game.ea052f44.mp3").toString();